import React from 'react';
import { createPortal } from 'react-dom';
import { FiAlertTriangle, FiInfo, FiCheckCircle, FiX } from 'react-icons/fi';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  type = 'warning' // 'warning', 'danger', 'info'
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'danger': return <FiAlertTriangle className="text-red-500 text-3xl" />;
      case 'info': return <FiInfo className="text-blue-500 text-3xl" />;
      case 'success': return <FiCheckCircle className="text-green-500 text-3xl" />;
      default: return <FiAlertTriangle className="text-amber-500 text-3xl" />;
    }
  };

  const getButtonColor = () => {
    switch (type) {
      case 'danger': return 'bg-red-600 hover:bg-red-700 focus:ring-red-500';
      case 'info': return 'bg-blue-600 hover:bg-blue-700 focus:ring-blue-500';
      case 'success': return 'bg-green-600 hover:bg-green-700 focus:ring-green-500';
      default: return 'bg-amber-600 hover:bg-amber-700 focus:ring-amber-500';
    }
  };

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white dark:bg-bg-1 rounded-2xl shadow-2xl max-w-md w-full border border-[var(--divider)] scale-100 animate-in zoom-in-95 duration-200">
        <div className="p-6">
          <div className="flex items-start gap-4">
            <div className={`p-3 rounded-full bg-opacity-10 shrink-0 ${
              type === 'danger' ? 'bg-red-500' :
              type === 'info' ? 'bg-blue-500' :
              type === 'success' ? 'bg-green-500' :
              'bg-amber-500'
            }`}>
              {getIcon()}
            </div>
            <div className="flex-1">
              <h3 className="ds-h3 text-fg-1 mb-2">
                {title}
              </h3>
              <p className="text-sm text-fg-2 leading-relaxed">
                {message}
              </p>
            </div>
          </div>
        </div>

        <div className="p-4 bg-bg-3/50 border-t border-[var(--divider)] rounded-b-2xl flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-fg-2 bg-bg-2 border border-[var(--divider)] rounded-lg hover:bg-bg-3 focus:outline-none focus:ring-2 focus:ring-gray-200 transition-colors"
          >
            {cancelText}
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className={`px-4 py-2 text-sm font-medium text-white rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors ${getButtonColor()}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmationModal;
